import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from "@angular/core";
import { ListPickerItem } from "../../../../../shared/components/pickers/listPicker/list-picker-item";
import { E911Location } from "../../../../../../../common/services/api/resources/e911/e911-location";
import { UserAddressE911Info } from "../../e911-table.component";
import { Observable, Subscription } from "rxjs";

@Component({
  selector: "onsip-admin-e911-table-shelf-view",
  templateUrl: "./e911-table-shelf-view.component.html",
  styleUrls: ["./e911-table-shelf-view.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AdminE911TableShelfViewComponent implements OnInit, OnDestroy {
  @Input() e911Location!: E911Location;
  @Input() userAddressE911Info!: Observable<Array<UserAddressE911Info>>;
  @Output() editPanel = new EventEmitter<void>();
  assignedUsers: Array<ListPickerItem> = [];

  private unsubscriber = new Subscription();

  constructor(private cdRef: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.unsubscriber.add(
      this.userAddressE911Info.subscribe(userE911Info => {
        this.assignedUsers = userE911Info
          .filter(userE911Info => userE911Info.e911LocationId === this.e911Location.e911LocationId)
          .map(userE911Info => ({ id: userE911Info.e911LocationId, name: userE911Info.name }));
        this.cdRef.markForCheck();
      })
    );
  }

  ngOnDestroy(): void {
    this.unsubscriber.unsubscribe();
  }

  togglePanel(): void {
    this.editPanel.next();
  }
}
